import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const UserDetailPasswordConfirm = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="confirm"
      label="Confirm Password"
      dependencies={["password"]}
      hasFeedback
      rules={[
        {
          required: true,
          message: "Please confirm your password!",
        },
        {
          min: 6,
          message: "Min length must be at least 6 characters",
        },
        {
          whitespace: true,
          message: "Invalid Password",
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (
              value &&
              getFieldValue("password") === value &&
              getFieldValue("oldPassword") === value
            ) {
              return Promise.reject(
                new Error(
                  "The new password look same with old password. Please try another one!"
                )
              );
            }

            if (!value || getFieldValue("password") === value) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error("The two passwords that you entered do not match!")
            );
          },
        }),
      ]}
    >
      <Input.Password
        showCount
        maxLength={16}
        minLength={6}
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Confirm Password"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserDetailPasswordConfirm;
